import React from 'react';

const NotFoundPage = () => (
  <div>找不到該頁面！</div>
);

export default NotFoundPage;
